module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_9.26cc6ba7.jpg";